import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  recordPaymentList: { loading: false, data: null, error: null },
  createRecordPayment: { loading: false, data: null, error: null },
  editRecordPayment: { loading: false, data: null, error: null },
  createStatusInvoice:{ loading: false, data: null, error: null },
  updateUTRDetails:{ loading: false, data: null, error: null },
  invoiceDueKpiDetails:{ loading: false, data: null, error: null },
  recievedSecurityDepositList:{ loading: false, data: null, error: null },
};

export const RecordPaymentSlice = createSlice({
  name: "recordPayment",
  initialState,
  reducers: {
    fetchrecordPaymentListRequest: (state, action) => {
      state.recordPaymentList.loading = true;
      state.recordPaymentList.error = null;
    },
    fetchrecordPaymentListSuccess: (state, action) => {
      state.recordPaymentList.data = action.payload;
      state.recordPaymentList.loading = false;
      state.recordPaymentList.error = null;
    },
    fetchrecordPaymentListFailure: (state, action) => {
      state.recordPaymentList.data = null;
      state.recordPaymentList.loading = false;
      state.recordPaymentList.error = action.payload;
    },

    fetchInvoiceKpiListRequest: (state, action) => {
      state.invoiceDueKpiDetails.loading = true;
      state.invoiceDueKpiDetails.error = null;
    },
    fetchInvoiceKpiListSuccess: (state, action) => {
      state.invoiceDueKpiDetails.data = action.payload;
      state.invoiceDueKpiDetails.loading = false;
      state.invoiceDueKpiDetails.error = null;
    },
    fetchInvoiceKpiListFailure: (state, action) => {
      state.invoiceDueKpiDetails.data = null;
      state.invoiceDueKpiDetails.loading = false;
      state.invoiceDueKpiDetails.error = action.payload;
    },

    recievedSecurityDepositListRequest: (state, action) => {
      state.recievedSecurityDepositList.loading = true;
      state.recievedSecurityDepositList.error = null;
    },
    recievedSecurityDepositListSuccess: (state, action) => {
      state.recievedSecurityDepositList.data = action.payload;
      state.recievedSecurityDepositList.loading = false;
      state.recievedSecurityDepositList.error = null;
    },
    recievedSecurityDepositListFaliure: (state, action) => {
      state.recievedSecurityDepositList.data = null;
      state.recievedSecurityDepositList.loading = false;
      state.recievedSecurityDepositList.error = action.payload;
    },


    createrecordPaymentRequest: (state, action) => {
      state.createRecordPayment.loading = true;
      state.createRecordPayment.error = null;
    },
    createrecordPaymentSuccess: (state, action) => {
      state.createRecordPayment.data = action.payload;
      state.createRecordPayment.loading = false;
      state.createRecordPayment.error = null;
      state.recordPaymentList = addNewRecord(action.payload, {
        ...state.recordPaymentList,
      });
    },
    createrecordPaymentFailure: (state, action) => {
      state.createRecordPayment.data = null;
      state.createRecordPayment.loading = false;
      state.createRecordPayment.error = action.payload;
    },

    invoiceStatusRequest: (state, action) => {
      state.createStatusInvoice.loading = true;
      state.createStatusInvoice.error = null;
    },
    invoiceStatusSuccess: (state, action) => {
      state.createStatusInvoice.data = action.payload;
      state.createStatusInvoice.loading = false;
      state.createStatusInvoice.error = null;
    },
    invoiceStatusFailure: (state, action) => {
      state.createStatusInvoice.data = null;
      state.createStatusInvoice.loading = false;
      state.createStatusInvoice.error = action.payload;
    },


    UTRDetailsRequest: (state, action) => {
      state.updateUTRDetails.loading = true;
      state.updateUTRDetails.error = null;
    },
    UTRDetailsSuccess: (state, action) => {
      state.updateUTRDetails.data = action.payload;
      state.updateUTRDetails.loading = false;
      state.updateUTRDetails.error = null;
    },
    UTRDetailsFailure: (state, action) => {
      state.updateUTRDetails.data = null;
      state.updateUTRDetails.loading = false;
      state.updateUTRDetails.error = action.payload;
    },

    editRecordPaymentRequest: (state, action) => {
      state.editRecordPayment.loading = true;
      state.editRecordPayment.error = null;
    },
    editRecordPaymentSuccess: (state, action) => {
      state.editRecordPayment.data = action.payload;
      state.editRecordPayment.loading = false;
      state.editRecordPayment.error = null;
      state.recordPaymentList = editRecord(action.payload, {
        ...state.recordPaymentList,
      });
    },
    editRecordPaymentFaliure: (state, action) => {
      state.editRecordPayment.data = null;
      state.editRecordPayment.loading = false;
      state.editRecordPayment.error = action.payload;
    },
    resetRecordPaymentForm: (state, action) => {
      //add
      state.createRecordPayment.data = null;
      state.createRecordPayment.loading = false;
      state.createRecordPayment.error = null;
      //edit
      state.editRecordPayment.data = null;
      state.editRecordPayment.loading = false;
      state.editRecordPayment.error = null;
    },
  },
});

function addNewRecord(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
function editRecord(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}
export const {
  fetchrecordPaymentListRequest,
  fetchrecordPaymentListSuccess,
  fetchrecordPaymentListFailure,
  
  createrecordPaymentRequest,
  createrecordPaymentSuccess,
  createrecordPaymentFailure,

  invoiceStatusRequest,
  invoiceStatusSuccess,
  invoiceStatusFaliure,

  UTRDetailsRequest,
  UTRDetailsSuccess,
  UTRDetailsFaliure,

  editRecordPaymentRequest,
  editRecordPaymentSuccess,
  editRecordPaymentFaliure,

  fetchInvoiceKpiListRequest,
  fetchInvoiceKpiListSuccess,
  // fetchInvoiceKpiListFaliure,
  fetchInvoiceKpiListFailure,
  recievedSecurityDepositListRequest,
  recievedSecurityDepositListSuccess,
  recievedSecurityDepositListFaliure,


  resetRecordPaymentForm,
} = RecordPaymentSlice.actions;

export const getRecordPaymentListState = (store) =>
  store.recordPayment?.recordPaymentList;

  export const getRecievedSecurityListState = (store) =>
  store.recordPayment?.recievedSecurityDepositList;

export const getRecordPaymentCreateState = (store) =>
  store.recordPayment?.createRecordPayment;

  export const getInvoiceStateData = (store) =>
  store.recordPayment?.createStatusInvoice;

  export const updateUTRStateData = (store) =>
  store.recordPayment?.updateUTRDetails;

  export const invoiceDueKpiStateData = (store) =>
  store.recordPayment?.invoiceDueKpiDetails;

export const editRecordPaymentState = (store) =>
  store.recordPayment.editRecordPayment;
export default RecordPaymentSlice.reducer;
